import { sanitisePathSegment } from "../../../../utils";
export const productDetailUrl = (vehicle)=>{
    if (!vehicle || !vehicle.make || !vehicle.model || !vehicle.id) {
        return "/used-cars";
    }
    return `/used-cars/${sanitisePathSegment(vehicle.make)}/${sanitisePathSegment(vehicle.model)}/details/${vehicle.id}`;
};
